
export function getStrapiURL(path = "") {
  return encodeURI(
    `${process.env.NEXT_PUBLIC_STRAPI_API_URL || "https://strapi.iskibris.com"}${path}`
  )
}

export function getStrapiMedia(media: any) {
  if (media == null) {
    return null
  }
  const mediaUrl = media?.data?.attributes?.url
  const imageUrl = mediaUrl?.startsWith("/") ? getStrapiURL(mediaUrl) : mediaUrl
  return imageUrl
}
